import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgWave = function SvgWave(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm0 2c5.52.006 9.994 4.48 10 10h-2.646c-.849 0-1.018-.276-1.6-1.448-.09-.182-.184-.371-.285-.565a1.519 1.519 0 00-1.443-.773c-.61.02-1.146.413-1.348.99l-1.6 5.1-2.626-9.756A1.476 1.476 0 009 4.5a1.479 1.479 0 00-1.455 1.04 144.047 144.047 0 00-.755 2.9C5.886 12 5.809 12 4.874 12H2c.006-5.52 4.48-9.994 10-10zM2.2 14a10.017 10.017 0 009.8 8 10.017 10.017 0 009.8-8h-2.446a3.244 3.244 0 01-3.129-2.044l-1.746 5.552a1.472 1.472 0 01-1.44.992h-.022a1.477 1.477 0 01-1.434-1.049L9 7.851l-.274 1.075C7.818 12.515 7.442 14 4.874 14H2.2z",
    clipRule: "evenodd"
  }));
};

export default SvgWave;